import { get } from 'lodash'
import utils from '@/common/util/utils'
import { DEVICE_TYPE_ANDROID, DEVICE_TYPE_IOS } from '@/common/devicetype.const'
import { getAdultVerificationStatus, UserService } from '@/common/api/api.service'
const device = utils.cookies.getDevice()
const loginInfoSubmit = (profileId, loginData) => {
  const loginInfo = JSON.stringify({
    profileId: profileId,
    loginInfo: loginData
  })
  try {
    if (device === DEVICE_TYPE_IOS) {
      window.webkit.messageHandlers.refreshLoginInfo.postMessage(loginInfo)
    } else if (device === DEVICE_TYPE_ANDROID) {
      window.Android.refreshLoginInfo(loginInfo)
    }
  } catch (e) {
    console.log(e)
  }
}
const profileInfoSubmit = (profileId, profileData) => {
  try {
    const profileInfo = JSON.stringify({
      profileId: profileId,
      profileInfo: profileData
    })
    if (device === DEVICE_TYPE_IOS) {
      window.webkit.messageHandlers.refreshProfileInfo.postMessage(profileInfo)
    } else if (device === DEVICE_TYPE_ANDROID) {
      window.Android.refreshProfileInfo(profileInfo)
    }
  } catch (e) {
    console.log(e)
  }
}
const userInfoSubmit = (userInfoData) => {
  try {
    if (device === DEVICE_TYPE_IOS) {
      window.webkit.messageHandlers.refreshUserInfo.postMessage(JSON.stringify({ userInfo: userInfoData }))
    } else if (device === DEVICE_TYPE_ANDROID) {
      window.Android.refreshUserInfo(JSON.stringify({ userInfo: userInfoData }))
    }
  } catch (e) {
    console.log(e)
  }
}
const adultSettingsInfoSubmit = (adultSettingsData) => {
  try {
    if (device === DEVICE_TYPE_IOS) {
      window.webkit.messageHandlers.refreshPinInfo.postMessage(JSON.stringify({ pinInfo: adultSettingsData }))
    } else if (device === DEVICE_TYPE_ANDROID) {
      window.Android.refreshPinInfo(JSON.stringify({ pinInfo: adultSettingsData }))
    }
  } catch (e) {
    console.log(e)
  }
}
export const appProfileChange = async (profileId) => {
  const loginRes = await UserService.login({ type: 'credential', id: utils.cookies.getCredential(), pushid: '', password: '', profile: profileId })
  const loginData = get(loginRes, 'data', {})
  const credential = get(loginData, 'credential', '')
  const profileRes = await UserService.getProfileDetailInfo(profileId, credential)
  const userInfoRes = await UserService.userInfo()
  const adultSettingInfoRes = await getAdultVerificationStatus()
  loginInfoSubmit(profileId, loginData)
  if (device === DEVICE_TYPE_IOS) {
    userInfoSubmit(get(userInfoRes, 'data', {}))
  } else if (device === DEVICE_TYPE_ANDROID) {
    profileInfoSubmit(profileId, get(profileRes, 'data', {}))
    adultSettingsInfoSubmit(get(adultSettingInfoRes, 'data', {}))
  }
}
export const appProfileEdit = async (profileId) => {
  let credential = utils.cookies.getCredential()
  const profileRes = await UserService.getProfileDetailInfo(profileId, credential)
  const { data } = await UserService.userInfo()
  const userInfoProfileId = get(data, 'profileid', '')
  if ((userInfoProfileId === profileId && device === DEVICE_TYPE_ANDROID) || (device === DEVICE_TYPE_IOS)) {
    profileInfoSubmit(profileId, get(profileRes, 'data', {}))
  }
}
